import PropTypes from 'prop-types';
import React from 'react';

const PureHiddenInput = ({ name, value }) => (
  <input name={name} type="hidden" value={value} />
);

PureHiddenInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default PureHiddenInput;
